<template>
  <div class="toast-stack-wrapper">

    <v-snackbar
      ref="snackbar"
      v-for="(item, index) in reversedToasts"
      :key="item.id"
      v-model="item.open"
      width="495"
      :timeout="-1"
      :class="['toast-container', item.data.type]"
      :style="{
        position: 'fixed',
        bottom: calcMargin(index),
        left: '50%',
        transform: 'translateX(-50%)'
      }">

      <!-- {{index}} -->
      <ToastBase :key="item.id" :item="item"/>

      <v-icon
        v-if="parseInt(item.timeout) === -1 || item.persist"
        icon="cancel" size="17"
        class="toast__clear-btn"
        @click="clear(item)" />
    </v-snackbar>

  </div>
</template>

<script>
import { loadShallowAsyncComponent } from '@/helpers/asyncLoaders'
import { mapState, mapActions } from 'vuex'

import {
  VUEX_TOAST_HIDE
} from '@/store/constants/ui/toast'

import ToastBase from '@/components/_core/Toast/Toast_BaseComponent.vue'

export default {
  name: 'toast-container',

  components: {
    ToastBase
  },

  data: () => ({
    snackbarHeights: []
  }),

  computed: {
    ...mapState({
      currentToasts: state => state.toast.currentToasts
    }),

    reversedToasts() {
      return [...this.currentToasts]/* .reverse() */
    },

    calcMargin() {
      return i => {
        const height = this.snackbarHeights.slice(0, i).reduce((acc, item) => acc + item, 0)
       return `${(height + 50 + (10 * i))}px`
      }
    }
  },

  methods: {
    ...mapActions({
      clearToast: VUEX_TOAST_HIDE
    }),

    loadContent (componentName) {
      return componentName ? loadShallowAsyncComponent(componentName) : null
    },

    clear (toast) {
      this.clearToast(toast.id)

      // Fire the close callback if it exists
      if (toast.closeCallback) toast.closeCallback()
    }
  },

  watch: {
    currentToasts: {
      deep: true,
      handler (value) {
        this.$nextTick(() => {
          this.snackbarHeights = Array.from(document.querySelectorAll('.toast-container')).map(item => item.querySelector('.v-snackbar__wrapper').offsetHeight)
        })
      }
    }
  }
}
</script>

<style lang="scss">
  .toast-container {
    .toast__clear-btn {
      position: absolute;
      top: 5px;
      right: 1%
    }

    .v-snackbar__wrapper {
      color: $app-color-text--dark;
      border-radius: 2px;
      min-height: 40px;
      background: white;
    }

    &.success {
      .v-snackbar__wrapper {
        border-top: 3px solid green;
        background: #E9F5EA
      }

      .toast__clear-btn {
        color: rgba(28,94,32,0.5);
      }
    }

    &.warning {
      .v-snackbar__wrapper {
        border-top: 3px solid rgba(214 ,209 ,36 ,1);
        background: #F5F4E9
      }

      .toast__clear-btn {
        color: rgba(130,127,22,0.5);
      }
    }

    &.error {
      .v-snackbar__wrapper {
        border-top: 3px solid red;
        background: #F5E9E9;
      }

      .toast__clear-btn {
        color: rgba(109,32,32,0.5);
      }
    }
  }
</style>
